import * as yup from 'yup';
import { METAL_TYPE } from '@frontend/api';
import { MIN_QUANTITY_REQUIRED_MT } from '@customer-platform-shared/components/Forms/Forms.const';
import { matchIsValidTel } from 'mui-tel-input';
import { maxNumbersAfterDecimalValidation } from '../SignUpForms/SignUpForms.utils';

type BuyerSignUpFormSchemaTranslations = {
  required: string;
  maxNumbersAfterDecimal: string;
  minQuantityRequired: string;
  validEmail: string;
  validPhoneNumber: string;
};

export default function getBuyerSignUpFormSchema(
  translations: BuyerSignUpFormSchemaTranslations,
) {
  return yup.object().shape({
    firstName: yup.string().required(translations.required),
    lastName: yup.string().required(translations.required),
    companyName: yup.string().required(translations.required),
    email: yup
      .string()
      .email(translations.validEmail)
      .required(translations.required),
    phoneNumber: yup
      .string()
      .test(
        'phoneNumberValidation',
        translations.validPhoneNumber,
        (phoneNumber = '') => {
          if (!phoneNumber) {
            return true;
          }
          return matchIsValidTel(phoneNumber);
        },
      )
      .required(translations.required),
    whatsappConsent: yup.boolean().optional(),
    metalType: yup
      .string()
      .oneOf(METAL_TYPE, translations.required)
      .required(translations.required),
    quantity: yup
      .number()
      .min(MIN_QUANTITY_REQUIRED_MT, translations.minQuantityRequired)
      .required(translations.required)
      .test(
        'maxNumbersAfterDecimal',
        translations.maxNumbersAfterDecimal,
        maxNumbersAfterDecimalValidation,
      )
      .transform((val, orig) => (orig === '' ? undefined : val)),
    productDescription: yup.string().optional(),
  });
}
